import Box from '@mui/material/Box';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import { classNames } from '@repo/ui/src/utils/classNames';
import { MobileNavItem, SecondaryNavText } from './styles';

const MobileIconOrPhotoLinks = ({ links, iconOrPhoto }) => {
  if (!links?.length) return null;

  return (
    <>
      {links.map((link, i) => {
        if (!link) return null;

        const linkObj = link.link ? buildLinkObj({ link: link.link }) : null;
        const image = link.imageContent || link.image;
        const imgUrl = !image
          ? null
          : iconOrPhoto === 'Icon'
            ? buildImageSrc(image, 27, 1, 1)
            : buildImageSrc(image, 70, 7, 5);

        return (
          <MobileNavItem
            key={linkObj?.text || i}
            component="a"
            href={linkObj.href}
            rel={getRel(linkObj)}
          >
            <Box display="flex" alignItems="center">
              {imgUrl && (
                <img
                  src={imgUrl}
                  alt={iconOrPhoto === 'Icon' ? '' : linkObj.text}
                  className={classNames('tw-mr-4', iconOrPhoto === 'Icon' && 'tw-w-9 tw-h-9')}
                />
              )}
              <SecondaryNavText>{link.displayName}</SecondaryNavText>
            </Box>
          </MobileNavItem>
        );
      })}
    </>
  );
};

export default MobileIconOrPhotoLinks;
